module.exports = __webpack_public_path__ + "fonts/Gilroy-Medium.woff?7d5dc1791cf2738d55a87e871549004c";